<ng-container *ngIf="!env.USE_TAILWIND">
    <div class="block--content block" id="main-content">
        <div class="block--wrap block">
            <rwidget-alert></rwidget-alert>
            <ridango-page-content-wrapper *ngIf="allowLogin">
                <div class="ticket" *ngIf="!passwordReset">
                    <rwidget-login-aside></rwidget-login-aside>

                    <div class="block__right-side-panel">
                        <rwidget-login
                            [captchaToggleAllowed]="captchaToggleAllowed"
                            [createAccountArea]="false"
                            [callback]="callback"
                            (onForcePasswordReset)="handlePasswordReset($event)"
                            (onLoginSuccess)="handleLogin($event)"
                            (onSubmitEmail)="submitEmail($event)"></rwidget-login>
                    </div>
                </div>

                <rwidget-email-sent *ngIf="passwordReset" [email]="email" [formerCustomerFirstVisit]="true">
                </rwidget-email-sent>
            </ridango-page-content-wrapper>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="env.USE_TAILWIND">
    <rwidget-alert></rwidget-alert>
    <div id="main-content">
        <div class="flex flex-row items-center justify-center bg-white pb-4 pt-6" *ngIf="env.IS_MOBILE_APP">
            <ridango-ui-back-button
                class="absolute left-4"
                *ngIf="showBackButton"
                (click)="handleBackClicked()"
                classIcon="w-7 h-7"></ridango-ui-back-button>
            <h1 class="var-app-light:font-bold text-center text-base font-semibold leading-5">
                {{ 'LOG_IN' | translate }}
            </h1>
        </div>
        <ng-container *ngIf="!passwordReset">
            <div class="overflow-hidden">
                <ng-container *ngIf="env.IS_MOBILE_APP">
                    <div class="max-content max-content--secondary min-h-[73vh] md:grid md:grid-cols-2">
                        <aside
                            class="pil-light-dark:justify-start relative hidden items-center justify-center py-4 before:absolute before:-left-[100vw] before:-right-[100vw] before:bottom-0 before:top-0 before:-z-10 before:bg-[#F8F8F8] before:content-[''] dark:before:bg-contrast-black md:flex md:h-auto md:pr-8 md:before:right-0">
                            <rwidget-login-aside class="md:w-full lg:max-w-[26rem]"></rwidget-login-aside>

                            <div
                                class="flex h-full items-center md:invisible md:w-auto lg:visible lg:w-[56%]"
                                *ngIf="env.THEME_NAME === themeFeature.PILET">
                                <img
                                    class="absolute -right-[2rem] z-10 h-[62vh] dark:filter-yellow"
                                    alt=""
                                    src="./assets/img/ridango-logo-shape.svg" />
                            </div>
                        </aside>

                        <section
                            class="pil-light-dark:lg:pl-20 relative flex max-w-2xl items-center justify-items-center bg-white py-5 before:absolute before:-left-[100vw] before:-right-[100vw] before:bottom-0 before:top-0 before:-z-10 before:bg-white before:content-[''] md:h-auto md:pl-8 md:before:left-0">
                            <rwidget-login
                                class="w-full"
                                [captchaToggleAllowed]="captchaToggleAllowed"
                                [createAccountArea]="false"
                                [callback]="callback"
                                (onForcePasswordReset)="handlePasswordReset($event)"
                                (onLoginSuccess)="handleLogin($event)"
                                (onSubmitEmail)="submitEmail($event)">
                            </rwidget-login>
                        </section>
                    </div>
                </ng-container>
                <ng-container *ngIf="!env.IS_MOBILE_APP">
                    <div class="max-content max-content--secondary md:grid md:min-h-[73vh] md:grid-cols-2">
                        <aside
                            class="pil-light-dark:justify-start relative hidden min-h-[20vh] items-center justify-center py-5 before:absolute before:-left-[100vw] before:-right-[100vw] before:bottom-0 before:top-0 before:-z-10 before:bg-[#F8F8F8] before:content-[''] dark:before:bg-contrast-black md:flex md:h-auto md:pr-8 md:before:right-0">
                            <rwidget-login-aside class="md:w-full lg:max-w-[26rem]"></rwidget-login-aside>

                            <div
                                class="flex h-full items-center md:invisible md:w-auto lg:visible lg:w-[56%]"
                                *ngIf="env.THEME_NAME === themeFeature.PILET">
                                <img
                                    class="absolute -right-[2rem] z-10 h-[62vh] dark:filter-yellow"
                                    alt=""
                                    src="./assets/img/ridango-logo-shape.svg" />
                            </div>
                        </aside>

                        <section
                            class="pil-light-dark:lg:pl-20 relative flex min-h-[60vh] max-w-2xl items-center justify-items-center bg-white py-5 before:absolute before:-left-[100vw] before:-right-[100vw] before:bottom-0 before:top-0 before:-z-10 before:bg-white before:content-[''] md:h-auto md:pl-8 md:before:left-0">
                            <rwidget-login
                                class="w-full"
                                [captchaToggleAllowed]="captchaToggleAllowed"
                                [createAccountArea]="false"
                                [callback]="callback"
                                (onForcePasswordReset)="handlePasswordReset($event)"
                                (onLoginSuccess)="handleLogin($event)"
                                (onSubmitEmail)="submitEmail($event)">
                            </rwidget-login>
                        </section></div
                ></ng-container>
            </div>
        </ng-container>

        <rwidget-email-sent *ngIf="passwordReset" [email]="email" [formerCustomerFirstVisit]="true">
        </rwidget-email-sent>
    </div>
</ng-container>
